import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { NotificationService } from '../services/notification.service';
import { NotificationInterface } from '../models/notification.interface';
import { NotificationTypeEnum } from '../enums/notification-type.enum';
import { SendItirenaryService } from '@services/send-itirenary.service';

/**
 * notification component
 */
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent {
  notifications: NotificationInterface[] = [];
  protected notificationTypeEnum = NotificationTypeEnum;

  constructor(
    private cdr: ChangeDetectorRef,
    private service: NotificationService,
    private itirenaryService: SendItirenaryService,
  ) {
    this.service.pool.subscribe((notification) => {
      this.notifications.push(notification);
      this.cdr.detectChanges();
      setTimeout(() => {
        this.notifications.splice(this.notifications.indexOf(notification), 1);
        this.cdr.detectChanges();
      }, notification.time);
    });
  }

  /**
   * dismiss notification
   * @param notification - notification message
   */
  dismiss(event, notification: NotificationInterface): void {
    event.stopPropagation();
    this.notifications.splice(this.notifications.indexOf(notification), 1);
    this.cdr.detectChanges();
    this.itirenaryService.dismissItineraryNotification(notification.notificationId).subscribe();
  }

  openNotificationLink(event, notification: NotificationInterface): void {
    event.stopPropagation();
    if (notification.link) {
      window.open(notification.link, '_blank');
      this.itirenaryService.dismissItineraryNotification(notification.notificationId).subscribe();
    }
  }
}
